<template>
  <custom-dialog :showClose="true" width="420px" v-if="show" :visible="show" @close="cancel">
    <div slot="header"></div>
    <div class="" slot="content" v-loading="loading">
      <div class="dialog_title">
        <div class="dialog_title_text">短信验证码支付</div>
        <i class="el-icon-close size16" @click="cancel"></i>
      </div>
      <div class="content">
        <div class="price">
          <span class="size16 font500">待支付:￥</span>
          <span class="size24 fwb">{{ dialogObj.price }}</span>
        </div>
        <el-input class="phone_input" placeholder="请输入手机号" v-model.trim="phone" maxlength="11">
          <template slot="append" v-if="phone.length == 11">
            <div class="send_btn" @click="sendCode" v-if="time === 0">发送验证码</div>
            <div v-else class="time_btn">{{ time }}s</div>
          </template>
        </el-input>
        <div class="tips" v-show="showCurAmount">钱包余额：<span class="fwb color0000">￥{{ curAmount }}</span></div>
        <el-input class="code_input" placeholder="请输入验证码" v-model="code"></el-input>
      </div>
      <div class="content_bottom">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import customDialog from '@/components/customDialog/CustomDialog'
import { sendSmsCode, clearSmsCode } from '@/api/pricingDetails'
import { isNull, debounce } from '@/utils/validateBase';
import { getWalletAmount } from '@/api/wallet'
export default {
  // 定义引入的组件
  components: { customDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogObj: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      phone: '',
      code: '',
      time: 0,
      curAmount: null,
      loading: false,
      showCurAmount: false,
    }
  },
  //变量监听
  watch: {
    dialogObj: {
      immediate: true,
      deep: true,
      handler() {
        this.phone = this.dialogObj.phone
      }
    }
  },
  // 页面初始化
  created() {
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    //取消
    async cancel() {
      await clearSmsCode({ phone: this.phone, walletTradeType: 2 })
      this.$emit('close')
    },
    //发送验证码
    sendCode: debounce(async function () {
      if (isNull(this.phone)) {
        this.$message.error('请输入手机号')
        return
      }
      this.getWalletAmount(this.phone, true)
    }, 500, true),

    //倒计时
    countdown(time) {
      clearTimeout(this.timeOut)
      if (time == 0) {
        this.btnText = '发送验证码'
      } else {
        this.timeOut = setTimeout(() => {
          time--;
          this.time = time
          this.btnText = `${time}s`
          this.countdown(time)
        }, 1000)
      }
    },
    //确定
    confirm() {
      if (isNull(this.code)) {
        this.$message.error('请输入验证码')
        return
      }
      if (!this.showCurAmount) {
        this.$message.error('请先发送验证码')
        return
      }
      let obj = { ...this.dialogObj, code: this.code, phone: this.phone, curAmount: this.curAmount }
      this.$emit('smsVerificationConfirm', obj)
    },
    //查询钱包余额
    getWalletAmount(phone, isSendCode = false) {
      return new Promise(async (resolve, reject) => {
        let { code, data } = await getWalletAmount({ phone })
        if (code == 200) {
          resolve(data.curAmount || 0)
          this.showCurAmount = true
          this.curAmount = data.curAmount || 0
          if (isSendCode) {
            sendSmsCode({ phone: this.phone, walletTradeType: '2' }).then(res2 => {
              if (res2.code == 200) {
                this.time = 60
                this.countdown(this.time)
              }
            })
          }
        }else{
          resolve(0)
        }
      })
    }
  },
}
</script>
<style lang="less" scoped>
.dialog_title {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid #E0E0E0;
  box-sizing: border-box;
}

.dialog_title_text {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}

/deep/.dialog-content {
  padding: 0;

}

.content {
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.price {
  color: #FE8F1F;
}

.phone_input {
  width: 260px;
  margin-top: 35px;

  /deep/.el-input__inner {
    height: 38px;
    color: #000;
  }

  /deep/.el-input-group__append {
    width: 110px;
    padding: 0;
    text-align: center;

    .send_btn {
      cursor: pointer;
      color: #1890FF;
      background: #E8F4FF;
      height: 36px;
      line-height: 36px;
    }

    .time_btn {
      cursor: not-allowed;
      height: 36px;
      line-height: 36px;
      background: #F5F7FA;
      color: #909399;
    }
  }
}

.tips {
  width: 260px;
  color: #667182;
  font-size: 12px;
  margin-top: 4px;
}

.code_input {
  width: 260px;
  margin-top: 20px;

  /deep/.el-input__inner {
    height: 38px;
  }
}

.content_bottom {
  width: 100%;
  margin-top: 48px;
  text-align: right;
  padding-right: 16px;
  padding-bottom: 16px;
  box-sizing: border-box;
}
</style>